import client from './client';

export interface Coupon {
  id: number;
  code: string;
  description?: string;
  discount_type: 'percentage' | 'flat';
  discount_value: number;
  min_order_amount: number;
  max_discount?: number;
  usage_limit?: number;
  used_count: number;
  store_id?: number;
  valid_from: string;
  valid_until: string;
  is_active: boolean;
  created_at: string;
}

export interface CouponCreate {
  code: string;
  description?: string;
  discount_type: 'percentage' | 'flat';
  discount_value: number;
  min_order_amount?: number;
  max_discount?: number;
  usage_limit?: number;
  valid_from: string;
  valid_until: string;
}

export interface CouponApplyResponse {
  valid: boolean;
  discount_amount: number;
  message: string;
  coupon?: Coupon;
}

export const couponsAPI = {
  async createCoupon(data: CouponCreate): Promise<Coupon> {
    const response = await client.post<Coupon>('/api/coupons', data);
    return response.data;
  },

  async listStoreCoupons(storeId: number, activeOnly: boolean = false): Promise<Coupon[]> {
    const response = await client.get<Coupon[]>(`/api/coupons/store/${storeId}`, {
      params: { active_only: activeOnly },
    });
    return response.data;
  },

  async listAvailableCoupons(storeId: number): Promise<Coupon[]> {
    const response = await client.get<Coupon[]>(`/api/coupons/available/${storeId}`);
    return response.data;
  },

  async applyCoupon(code: string, storeId: number, subtotal: number): Promise<CouponApplyResponse> {
    const response = await client.post<CouponApplyResponse>('/api/coupons/apply', {
      code,
      store_id: storeId,
      subtotal,
    });
    return response.data;
  },

  async updateCoupon(couponId: number, data: Partial<CouponCreate>): Promise<Coupon> {
    const response = await client.put<Coupon>(`/api/coupons/${couponId}`, data);
    return response.data;
  },

  async deleteCoupon(couponId: number): Promise<any> {
    const response = await client.delete(`/api/coupons/${couponId}`);
    return response.data;
  },
};

